import React, { PureComponent, PropTypes } from 'react';
import Guide from './guide';

export default class extends PureComponent {
    static propTypes = {
        onCancel: PropTypes.func.isRequired,
        onStart: PropTypes.func.isRequired
    }
    showHint(activeHint) {
        this.setState({ activeHint });
    }
    render() {
        const { onCancel, onStart } = this.props;

        return (<div className="intro">
            <h1>Import new deck</h1>
            <p>If you already have your own word list file and just want to import it and start practicing, you can!</p>
            <p>Just copy the text of your card data directly into the importer and it will attempt to sort everything into tidy columns. If you are happy with the results, select the columns you want to appear on your cards. It is quick and simple.</p>
            <p>What can you copy your data from?</p>
            <div>
                <Guide />
            </div>
            <div className="buttons">
                <button onClick={ onCancel }>Cancel</button>
                <button onClick={ onStart }>Start</button>
            </div>
        </div>);
    }
}


// WEBPACK FOOTER //
// ./src/components/importer/intro.js